import React, { useEffect, useState } from "react";
import '../style.scss';
import SearchFilter from "../../../components/search-filter";
import { convertSeconds, formatDate, startLoader, stopLoader } from "../../../lib/utils";
import { getAllBranches, getBranchCount } from "../../gyms/helper/api";
import { updatePublishedMediaRecord } from "../helper/api";
import Toast from "../../../lib/toast";
import HlsPlayer from '../../../components/hlsPlayer';
import { isAuthenticated } from "../../../auth";
// import config from "../../../config";
import client from "../../../clients";

const LiveAdsPreviewModal = (props) => {

  const [currentView, setCurrentView] = useState("ads-preview");
  const [currentSelectedBranch, setCurrentSelectedBranch] = useState(-1);
  const [currentBranch, setCurrentBranch] = useState(-1);
  const [mediaRecord,setMediaRecord] = useState(null);
  const [startBranchLoader,setStartBranchLoader]=useState(false)
  const [tempSelectedBranches, setTempSelectedBranches] = useState([])
  const [isButtonlock,setButtonLock] = useState(false);
  const [selectedBranchList, setSelectedBranchList] = useState([
    // {
    //   branchName: "Branch Name, location",
    //   isSelected: false,
    //   devices: [
    //     {
    //       name: "Kiosk, Kiosk Name",
    //       isSelected: false,
    //       isActive: true,
    //       upTime: "2 Days, 3 hrs"
    //     },
    //     {
    //       name: "Kiosk, Kiosk Name",
    //       isSelected: false,
    //       isActive: false
    //     }
    //   ]
    // },
    // {
    //   branchName: "Branch, location",
    //   isSelected: false,
    //   devices: [
    //     {
    //       name: "Kiosk Name, Kiosk Name",
    //       isSelected: false,
    //       isActive: true,
    //       upTime: "1 Days, 23 hrs"
    //     }
    //   ]
    // }
  ]);
  const [branchList, setBranchList] = useState([
    // {
    //   branchName: "Branch Name, location",
    //   isSelected: false,
    //   devices: [
    //     {
    //       name: "Kiosk, Kiosk Name",
    //       isSelected: false,
    //     },
    //     {
    //       name: "Kiosk, Kiosk Name",
    //       isSelected: false,
    //     }
    //   ]
    // },
    // {
    //   branchName: "Branch, location",
    //   isSelected: false,
    //   devices: [
    //     {
    //       name: "Kiosk Name, Kiosk Name",
    //       isSelected: false
    //     }
    //   ]
    // }
  ]);

  var [pageNo,setPageNo]=useState({
    branch:1
  })
  const pageSize = {
    branch:20
  }
  var [pageCount,setPageCount]=useState({
    branch:1
  })
  var [total,setTotal] = useState({
    branch:1
  });
  const [branchSearchKey,setBranchSearchKey] = useState('');
  const {user,token} = isAuthenticated();

  const [isAdsViewVisible,setAdsViewVisible] = useState(false);

  const handleBranchSearchKey = event =>{
    setBranchSearchKey(event.target.value);
  }

  const GetBranchParams = () =>{
    const params = {
      pageNo:pageNo.branch,
      pageSize:pageSize.branch,
      haveKioskDevice:true
    };
    if(selectedBranchList.length) params.excludeIDs=selectedBranchList.map(d=>d._id);
    if(branchSearchKey) params.q = branchSearchKey;
    return params;
  }

  const GetBranches=async (isReload)=>{
    try{
      const params = GetBranchParams();
      const response = await getAllBranches(user._id,token,params);
      if(response.error){

      }else{
        await Promise.all(response.map(d=>{
          d.devices.map(d=>{
            d.isActive=false;
            d.isSelected=false;
          })
        }));
        if(isReload) setBranchList(response);
        else setBranchList([...branchList,...response]);
      }
    }catch(error){
      console.error(error)
    }
    setStartBranchLoader(false)
  }

  const GetBranchCount=async (isReload)=>{
    try{
      const params = GetBranchParams();
      delete params.pageNo
      delete params.pageSize
      const response = await getBranchCount(user._id,token,params);
      if(response.error){

      }else{
        pageNo.branch = 1;
        setPageNo({
          ...pageNo
        })
        pageCount.branch = Math.ceil(response.COUNT / pageSize.branch);
        setPageCount({
          ...pageCount
        })
        total.branch = response.COUNT;
        setTotal({
          ...total
        })
      }
    }catch(error){
      console.error(error)
    }
  }

  const UpdatePublishedMediaRecord = (Unblock=false,branchData) => async event =>{
    try{
      await startLoader()
      setButtonLock(true);

      const payload =  {
        selectedBranches:[],
        action:Unblock?'unblock':'block'
      }

      if(!branchData){
        if(selectedBranchList.length){
          await Promise.all(selectedBranchList.map(data=>{
            let dataObject={
              branchId:data._id,
              deviceIds:[]
            }
            dataObject.deviceIds = data.devices.filter(d=>d.isSelected).map(d=>d._id);

            payload.selectedBranches.push(dataObject);
          
          }))
        }
      }else{
        let dataObject={
          branchId:branchData.branchId,
          deviceIds:[branchData.deviceID]
        }
        payload.selectedBranches.push(dataObject);
      }


      const response = await updatePublishedMediaRecord(user._id,token,mediaRecord._id,payload);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Something went wrong please try again"
        })
      }else{
        setSelectedBranchList(oldState=>{
          if(branchData){
            oldState[branchData.branchIndex].devices[branchData.deviceIndex].isSelected=false;
            oldState[branchData.branchIndex].devices[branchData.deviceIndex].isActive=Unblock?true:false;
          }else{
            oldState.filter(d=>d.isSelected).map(branch=>{
                if(branch.devices.length){
                  if(branch.devices.filter(d=>d.isSelected).length){
                    branch.devices.filter(d=>d.isSelected).map(device=>{
                      device.isSelected = false;
                      device.isActive = Unblock ? true : false;
                    });
                  }else{
                    branch.devices.map(device=>{
                      device.isSelected = false;
                      device.isActive = Unblock ? true : false;
                    })
                  }
                }
            })
          }
          return [...oldState];
        });

        new Toast({
          type:"success",
          duration:3000,
          message:"Your Changes Updated Successfully"
        })
      }

      setButtonLock(false)
      await stopLoader()
    }catch(error){
      await stopLoader();
      setButtonLock(false)
    }
  }
  
  const handleScrollBranch = async event => {
    const { offsetHeight, scrollTop, scrollHeight } = event.target;
    if (offsetHeight + scrollTop === scrollHeight && pageNo.branch < pageCount.branch) {
      pageNo.branch = pageNo.branch + 1;
      setPageNo(pageNo)
      setStartBranchLoader(true)
      await GetBranches();
      setStartBranchLoader(false)
    }
  }

  const toggleSelectedBranchExpand = (index) => {
    if(currentSelectedBranch == index){
      setCurrentSelectedBranch(-1)
    }else{
      setCurrentSelectedBranch(index)
    }
  }

  const toggleBranchExpand = (index) => {
    if(currentBranch == index){
      setCurrentBranch(-1)
    }else{
      setCurrentBranch(index)
    }
  }

  const handleSelectBranchList = (index) => {
    setSelectedBranchList(oldState =>
      oldState.map((item, i) =>
        i === index
          ? {
              ...item,
              isSelected: !item.isSelected,
              devices: item.isSelected
              ? item.devices.map((device) => ({
                  ...device,
                  isSelected: false
                }))
              : item.devices.map((device) => ({
                  ...device,
                  isSelected: true
                }))
            }
          : item
      )
    );
  }

  const handleBranchList = (index) => {
   
      setTempSelectedBranches(oldState=>{
        let findIndex=oldState.findIndex(d=>d._id==branchList[index]._id);
        if(!branchList[index].isSelected && findIndex==-1) oldState.push(branchList[findIndex])
        if(branchList[index].isSelected && findIndex>-1) oldState.splice(findIndex,1)  
        
        return [...oldState];
      })

    setBranchList(oldState =>
      oldState.map((item, i) =>
        i === index
          ? {
              ...item,
              isSelected: !item.isSelected,
              devices: item.isSelected
              ? item.devices.map((device) => ({
                  ...device,
                  isSelected: false
                }))
              : item.devices.map((device) => ({
                  ...device,
                  isSelected: device.isActive
                }))
            }
          : item
      )
    );

  

    
  }

  const handleDeviceSelect = (deviceType, branchIndex, deviceIndex) => {
    (deviceType === "selected-branch" ? setSelectedBranchList : setBranchList)((oldState) =>{
      if(deviceType == "selected-branch"){
        oldState[branchIndex].devices[deviceIndex].isSelected =  oldState[branchIndex].devices[deviceIndex].isSelected?false:true;
        oldState[branchIndex].isSelected = oldState[branchIndex].devices.filter(d=>d.isSelected).length?true:false;
      }
      return deviceType === "selected-branch"?[...oldState]:oldState.map((branch, i) =>
        i === branchIndex
          ? {
              ...branch,
              devices: branch.devices.map((device, j) =>
                j === deviceIndex
                  ? {
                      ...device,
                      isSelected: !device.isSelected,
                    }
                  : device
              ),
            }
          : branch
      );
    });
  }

  const handleDeviceState = (deviceType,branchIndex, deviceIndex) => {
    (deviceType === "selected-branch" ? setSelectedBranchList : setBranchList)((oldState) =>
      oldState.map((branch, i) =>
        i === branchIndex
          ? {
              ...branch,
              devices: branch.devices.map((device, j) =>
                j === deviceIndex
                  ? {
                      ...device,
                      isSelected: !device.isSelected,
                      isActive: !device.isActive,
                    }
                  : device
              ),
            }
          : branch
      )
    );
  }

  const showLiveDeviceCount = (branches) =>{
    let count=0;
    branches.map(d=>{
      let selectedDevices = d.devices.filter(d2=>d2.isActive);
      
      count = count + selectedDevices.length;
    })
    return count;
  }

  const adsMetaDetail = (deviceId) =>{
    let result = {
      upTime:'0s'
    }

    if(mediaRecord && mediaRecord.adsmetadetails){
      const data = mediaRecord.adsmetadetails.find(d=>deviceId == d.deviceId);
      if(data) result.upTime = convertSeconds(data.upTime);
    }

    return result;
  }

  useEffect(()=>{
    if(props.mediaRecord){
      setMediaRecord(props.mediaRecord)
      let branches =[];
      if(props.mediaRecord.branch && props.mediaRecord.branch.length){
        branches=[...branches,...props.mediaRecord.branch];
      }
      if(props.mediaRecord.branches && props.mediaRecord.branches.length){
        branches=[...branches,...props.mediaRecord.branches];
      }

      branches.map(d=>{
       d.devices.map(d2=>{
        if(!props.mediaRecord.disabledDeviceIDs) props.mediaRecord.disabledDeviceIDs=[]
        d2.isActive=(props.mediaRecord.disabledDeviceIDs.findIndex(id=>id == d2._id)==-1)?true:false;
       })
      })
  
      setSelectedBranchList(branches);

    }

  
  },[props])

  useEffect(async ()=>{
    setStartBranchLoader(true)
    await GetBranchCount()
    await GetBranches(true)
  },[branchSearchKey])

  const hlsUrl = mediaRecord =>{
    let url = "";
    const files = mediaRecord.file;
    if(files && files.length>0){
        const file = files[0];
        if(file.secondaryStorageDetail){
            const secondaryStorageDetail = file.secondaryStorageDetail;
            if(secondaryStorageDetail.outPutFilePath){
                const outPutFilePath = secondaryStorageDetail.outPutFilePath;
                url = client.config.videoDistributionHost+"/"+outPutFilePath;
            }
        }
    }
    return url;
  }

  const onEndedVideo = data => e =>{
    const video = e.target;
    video.src = `${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}?t=${Date.now()}`;
    video.load();
    video.play();
  }

  const horizontalAds = () => {
    return(
      <div className="horizontal-ads-container margin-auto m-t-12 bg-dark-blue">
        <div className="published-ads-header bg-white w-full p-l-12 p-r-12">
          <div className="d-flex w-full h-full space-between">
            <div className="d-flex flex-item">
              <svg className="flex-item m-r-6" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.625 6.5C11.625 6.3674 11.6799 6.24021 11.7776 6.14644C11.8752 6.05268 12.0077 6 12.1458 6H13.1875C13.3256 6 13.4581 6.05268 13.5557 6.14644C13.6534 6.24021 13.7083 6.3674 13.7083 6.5V7.5C13.7083 7.6326 13.6534 7.75979 13.5557 7.85356C13.4581 7.94732 13.3256 8 13.1875 8H12.1458C12.0077 8 11.8752 7.94732 11.7776 7.85356C11.6799 7.75979 11.625 7.6326 11.625 7.5V6.5Z" fill="var(--darkBlue)"/>
                <path d="M3.81185 0C3.94998 0 4.08246 0.0526784 4.18014 0.146446C4.27781 0.240215 4.33268 0.367392 4.33268 0.5V1H12.666V0.5C12.666 0.367392 12.7209 0.240215 12.8186 0.146446C12.9162 0.0526784 13.0487 0 13.1868 0C13.325 0 13.4575 0.0526784 13.5551 0.146446C13.6528 0.240215 13.7077 0.367392 13.7077 0.5V1H14.7493C15.3018 1 15.8318 1.21071 16.2225 1.58579C16.6131 1.96086 16.8327 2.46956 16.8327 3V14C16.8327 14.5304 16.6131 15.0391 16.2225 15.4142C15.8318 15.7892 15.3018 16 14.7493 16H2.24935C1.69681 16 1.16691 15.7892 0.77621 15.4142C0.385509 15.0391 0.166016 14.5304 0.166016 14V3C0.166016 2.46956 0.385509 1.96086 0.77621 1.58579C1.16691 1.21071 1.69681 1 2.24935 1H3.29102V0.5C3.29102 0.367392 3.34589 0.240215 3.44356 0.146446C3.54124 0.0526784 3.67372 0 3.81185 0ZM1.20768 4V14C1.20768 14.2652 1.31743 14.5196 1.51277 14.7071C1.70813 14.8947 1.97308 15 2.24935 15H14.7493C15.0256 15 15.2906 14.8947 15.4859 14.7071C15.6813 14.5196 15.791 14.2652 15.791 14V4H1.20768Z" fill="var(--darkBlue)"/>
              </svg>
              <p className="flex-item fs-16 color-dark-blue font-weight-600">{"Upload Date"}</p>
              {/* mediaRecord.publishDate?"Publish Date": mediaRecord.publishDate?formatDate(new Date(mediaRecord.publishDate)): */}
            </div>
            <p className="fs-16 color-red font-weight-700 flex-item">{formatDate(new Date(mediaRecord.createdAt))}</p>
          </div>
        </div>
        {(mediaRecord.urlType && mediaRecord.urlType == 'mp4')?(
             <video onEnded={onEndedVideo(mediaRecord)} width="100%" height="92%" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${mediaRecord.fileID}`} controls autoPlay />
          ):        <img className="flex-item" style={{objectFit:'cover'}} src={`${client.config.API_URL}/image/file/${mediaRecord.fileID}/auto/auto/50`} />}
        <div className="w-full d-flex m-t-5">
          <p className="margin-auto fs-14 font-weight-600 color-white">{mediaRecord.name}</p>
        </div>
      </div>
    )
  }



  const verticalAds = () => {
    return(
      <div className="vertical-ads-container margin-auto m-t-12 bg-dark-blue">
        <div className="published-ads-header bg-white w-full p-l-12 p-r-12">
          <div className="d-flex w-full h-full space-between">
            <div className="d-flex flex-item">
              <svg className="flex-item m-r-6" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.625 6.5C11.625 6.3674 11.6799 6.24021 11.7776 6.14644C11.8752 6.05268 12.0077 6 12.1458 6H13.1875C13.3256 6 13.4581 6.05268 13.5557 6.14644C13.6534 6.24021 13.7083 6.3674 13.7083 6.5V7.5C13.7083 7.6326 13.6534 7.75979 13.5557 7.85356C13.4581 7.94732 13.3256 8 13.1875 8H12.1458C12.0077 8 11.8752 7.94732 11.7776 7.85356C11.6799 7.75979 11.625 7.6326 11.625 7.5V6.5Z" fill="var(--darkBlue)"/>
                <path d="M3.81185 0C3.94998 0 4.08246 0.0526784 4.18014 0.146446C4.27781 0.240215 4.33268 0.367392 4.33268 0.5V1H12.666V0.5C12.666 0.367392 12.7209 0.240215 12.8186 0.146446C12.9162 0.0526784 13.0487 0 13.1868 0C13.325 0 13.4575 0.0526784 13.5551 0.146446C13.6528 0.240215 13.7077 0.367392 13.7077 0.5V1H14.7493C15.3018 1 15.8318 1.21071 16.2225 1.58579C16.6131 1.96086 16.8327 2.46956 16.8327 3V14C16.8327 14.5304 16.6131 15.0391 16.2225 15.4142C15.8318 15.7892 15.3018 16 14.7493 16H2.24935C1.69681 16 1.16691 15.7892 0.77621 15.4142C0.385509 15.0391 0.166016 14.5304 0.166016 14V3C0.166016 2.46956 0.385509 1.96086 0.77621 1.58579C1.16691 1.21071 1.69681 1 2.24935 1H3.29102V0.5C3.29102 0.367392 3.34589 0.240215 3.44356 0.146446C3.54124 0.0526784 3.67372 0 3.81185 0ZM1.20768 4V14C1.20768 14.2652 1.31743 14.5196 1.51277 14.7071C1.70813 14.8947 1.97308 15 2.24935 15H14.7493C15.0256 15 15.2906 14.8947 15.4859 14.7071C15.6813 14.5196 15.791 14.2652 15.791 14V4H1.20768Z" fill="var(--darkBlue)"/>
              </svg>
              <p className="flex-item fs-16 color-dark-blue font-weight-600">Upload Date</p>
              {/* {mediaRecord.publishDate?formatDate(new Date(mediaRecord.publishDate)): */}
            </div>
            <p className="fs-16 color-red font-weight-700 flex-item">{formatDate(new Date(mediaRecord.createdAt))}</p>
          </div>
        </div>
        {
          (mediaRecord.urlType && mediaRecord.urlType == 'hls')?(
            <HlsPlayer className="video-hls" videoSrc={hlsUrl(mediaRecord)}/>
          ):(mediaRecord.urlType && mediaRecord.urlType == 'mp4')?(
             <video onEnded={onEndedVideo(mediaRecord)} width="100%" height="92%" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${mediaRecord.fileID}`} controls autoPlay />
          ):(
            <img className="flex-item" style={{width:'100%',height:'93%',borderRadius:"12px"}} src={`${client.config.API_URL}/image/file/${mediaRecord.fileID}/auto/auto/auto`} />
          )
        }
        
        <div className="w-full d-flex m-t-5">
          <p className="margin-auto fs-14 font-weight-600 color-white">{mediaRecord.name}</p>
        </div>
      </div>
    )
}

  const toggleCurrentView = (view) => {
    setCurrentView(view)
  }

  const toggleAdsView = () => {
    setAdsViewVisible(!isAdsViewVisible)
  }

  const isActiveDevice = deviceId =>{
    let result = false;
    if(mediaRecord && mediaRecord.branches && mediaRecord.branches.length){
      let activeDevice =[];
      mediaRecord.branches.forEach(branch=>{
        activeDevice = [...activeDevice,...branch.activeDevice];
      })
      //branches
      const foundDevice = activeDevice.find(d=>d._id == deviceId);
      if(foundDevice) result = true;
    }
    return result;
  }

  const isBranchSelected = (branches) =>{
    let result=false;

    result = branches.filter(data=>data.isSelected).length?true:false;

    if(!result){
       let devices=[];

       branches.map(data=>{
        devices=[...devices,...data.devices];
       });
       
       result = devices.filter(data=>data.isSelected).length?true:false;
    }



    return result;
  }

  const handleSelectNewBranch = event =>{
    //setTempSelectedBranches
  }

  if(!mediaRecord){
    return<></>
  }

  return(
    <div className="global-modal-container d-flex">
      <div className={`${mediaRecord.isMainScreenBanner ? "horizontal-ads-preview-modal" : "vertical-ads-preview-modal"} global-modal-type-2 flex-item`}>
        <div className="d-flex w-full space-between" style={{background: "#DEF3FF", padding:"12px", borderRadius: "16px 16px 0 0"}}>
          <div className='d-flex'>
            <svg className='flex-item m-r-12' width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 15.2632L20.2239 24.4962L20.3176 24.6631C20.8373 25.5607 21.6327 26.2593 22.5812 26.6513C23.5296 27.0432 24.5784 27.1067 25.5658 26.832C26.5532 26.5572 27.4244 25.9595 28.045 25.1309C28.6656 24.3024 29.0012 23.289 29 22.2472C29.0029 21.4126 28.7881 20.5921 28.3775 19.8697L28.3261 19.7844L19.2501 3.79113V3.78652C18.0898 1.72892 16.8909 1 15 1C14.1969 0.99937 13.4073 1.21 12.7078 1.61147C12.0082 2.01294 11.4225 2.59161 11.0074 3.29134L10.8813 3.51509C10.53 4.18173 10.3336 4.94449 10.3336 5.74953C10.3316 6.51387 10.5115 7.26733 10.8579 7.94553L10.8903 8.00781L11.0218 8.23156L15 15.2632ZM15 15.2632L9.76699 24.5154M9.76699 24.5154C10.1273 23.8388 10.3336 23.0668 10.3336 22.2472C10.3337 21.2177 10.0045 20.2161 9.39694 19.3931C8.78939 18.5701 7.93561 17.9703 6.96412 17.6839C5.99264 17.3975 4.95604 17.44 4.01037 17.8051C3.06471 18.1702 2.26116 18.8381 1.7207 19.7082M9.76699 24.5154L9.68313 24.6677C9.27029 25.3778 8.68271 25.9662 7.97834 26.3748C7.27396 26.7833 6.47713 26.9979 5.66641 26.9975C5.05346 26.9978 4.44646 26.8751 3.88013 26.6365C3.31379 26.3979 2.79921 26.048 2.36583 25.6068C1.93244 25.1656 1.58875 24.6418 1.35439 24.0653C1.12003 23.4889 0.999604 22.871 1 22.2472C1 21.4475 1.19189 20.694 1.53864 20.0327L1.71617 19.7175L1.7207 19.7082M1.7207 19.7082L10.8813 3.51432" stroke="var(--darkBlue)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p className="flex-item fs-18 font-weight-700 color-dark-blue">Ads Preview</p>
          </div>
          <div onClick={props.close} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
            <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
            </svg>
          </div>
        </div>
        <div className={`${!mediaRecord.isMainScreenBanner && "d-flex"} w-full`} style={{height: !mediaRecord.isMainScreenBanner ? "85%" : "91%"}}>
          {
            !mediaRecord.isMainScreenBanner && verticalAds()
          }
          {
            mediaRecord.isMainScreenBanner && horizontalAds()
          }
          {
            false && (currentView == "ads-preview" ? (
              <div className="horizontal-ads-scroll-container" style={{width: !mediaRecord.isMainScreenBanner ? "58%" : "100%"}}>
                {
                  mediaRecord.isMainScreenBanner && horizontalAds()
                }
                <div className="p-l-12 p-r-12">
                  <div className="d-flex m-t-18 m-b-20 space-between">
                    <p className="flex-item fs-16 color-black font-weight-700">Live Device(s)</p>
                    <svg className="flex-item" width="64%" height="auto" viewBox="0 0 219 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0.49862" y1="1.375" x2="218.503" y2="1.625" stroke="#D0D0D0" stroke-dasharray="4 4"/>
                    </svg>
                    <div className="total-active-devices-container bg-dark-blue d-flex">
                      <p className="flex-item fs-16 font-weight-600 margin-auto color-white">{showLiveDeviceCount(selectedBranchList)}</p>
                    </div>
                  </div>
                  <div style={mediaRecord.isMainScreenBanner?{}:{height:'58vh',overflowY:'auto'}}>
                  {
                    selectedBranchList.map((data, index) => {
                      return(
                        <div className={`${currentSelectedBranch == index &&  "scaleFromTopToBottom"} w-full m-t-12`} style={{borderBottom: selectedBranchList.length  != index + 1 ? "1px solid #e0e0e0" : "", paddingBottom: currentSelectedBranch == index && "14px"}}>
                          <div className="d-flex space-between m-b-16">
                            <div onClick={()=>handleSelectBranchList(index)} className="d-flex">
                              <input className="flex-item device-checkbox m-r-8" type="checkbox" checked={data.isSelected} />
                              <div className="d-flex">
                              {
                                    data.gym[0].logoFileID?(
                                      <div className="table-item-profile d-flex flex-item">
                                        <img className="flex-item" src={`${client.config.API_URL}/image/file/${data.gym[0].logoFileID}/auto/auto/70`} />
                                      </div>
                                    ):(
                                      <div className="gym-logo m-r-8 m-t-1" style={{backgroundColor: data.gym[0].logoPlaceholderColor ? data.gym[0].logoPlaceholderColor : "#5d883c"}}>
                                          <div className='d-flex w-full h-full'>
                                            <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${data.gym[0].name}`.trim()[0]}</p>
                                          </div>
                                      </div>
                                    )
                                  }
                                <div className="flex-item m-l-8">
                                  <p className="fs-16 font-weight-600 color-dark-blue" style={{lineHeight:"16px"}}>{data.name}</p>
                                  <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{data.devices.length} Device{data.devices.length > 1 && "s"}</p>
                                </div>
                              </div>
                            </div>
                            <div onClick={()=>toggleSelectedBranchExpand(index)} className="table-action-button d-flex cursor-pointer" style={{backgroundColor: currentSelectedBranch == index ? "#E33A34" : "#ffffff"}}>
                              <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: currentSelectedBranch == index ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={currentSelectedBranch == index ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                              </svg>
                            </div>
                          </div>
                          {
                            currentSelectedBranch == index && (
                              data.devices.map((device, deviceIndex) => {
                                {/* handleDeviceSelect("selected-branch", index, deviceIndex) onClick={()=>device.isActive ? null : handleDeviceState("selected-branch",index, deviceIndex)}*/}
                                return(
                                  <div className="d-flex m-l-32 m-b-6 cursor-pointer">
                                    {
                                      device.isActive ? (
                                        <input onClick={()=>handleDeviceSelect("selected-branch", index, deviceIndex)} className="device-checkbox m-r-8 m-t-4" type="checkbox" checked={device.isSelected} />                                
                                      ) : (
                                        <svg onClick={isButtonlock?null:UpdatePublishedMediaRecord(true,{branchId:data._id,deviceID:device._id,branchIndex:index, deviceIndex:deviceIndex})} className="m-r-8 m-t-3" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1 8H15M8 15V1" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                      )
                                    }
                                    <div className="m-l-10">
                                      <div className="d-flex" style={{marginTop: !device.isSelected ? "5px" : "-3px"}}>
                                        <p className="flex-item m-r-8 font-weight-600 color-black" style={{lineHeight:"14px"}}>{device.name?device.name:device.deviceID}</p>                                  
                                        {
                                          device.isActive && (
                                            <div className="flex-item status-icon m-r-8" style={{backgroundColor:isActiveDevice(device._id)?'#00A603':'#9a9a9a'}} />
                                          )
                                        }
                                        {
                                          device.isSelected && device.isActive && (
                                            <div onClick={isButtonlock?null:UpdatePublishedMediaRecord(false,{branchId:data._id,deviceID:device._id,branchIndex:index, deviceIndex:deviceIndex})} className="table-action-button d-flex cursor-pointer">
                                              <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms"}} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.5776 13.5768L3.42373 3.42299M1.16732 8.49992C1.16732 6.555 1.93993 4.68973 3.3152 3.31447C4.69047 1.9392 6.55573 1.16658 8.50065 1.16658C10.4456 1.16658 12.3108 1.9392 13.6861 3.31447C15.0614 4.68973 15.834 6.555 15.834 8.49992C15.834 10.4448 15.0614 12.3101 13.6861 13.6854C12.3108 15.0606 10.4456 15.8333 8.50065 15.8333C6.55573 15.8333 4.69047 15.0606 3.3152 13.6854C1.93993 12.3101 1.16732 10.4448 1.16732 8.49992Z" stroke="#E33A34" stroke-linejoin="round"/>
                                              </svg>
                                            </div>
                                          )
                                        }
                                      </div>
                                      {/* {
                                        (adsMetaDetail(device._id).upTime) && ( */}
                                          <p className="flex-item fs-10 color-blue" style={{marginTop: device.isSelected && "-8px"}}>{adsMetaDetail(device._id).upTime}</p>
                                        {/* )
                                      } */}
                                    </div>
                                  </div>
                                )
                              })
                            )
                          }
                        </div>
                      )
                    })
                  }
                  </div>
                  <div className="modal-bottom-action-container d-flex">
                    {
                      !isBranchSelected(selectedBranchList) ? (
                        <div onClick={()=>toggleCurrentView("add-branch")} className="d-flex flex-item margin-auto cursor-pointer">
                          <svg className="flex-item m-r-6" width="18" height="18" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 6.5H11M6 11.5V1.5" stroke="#4d4d4d" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <p className="flex-item fs-16 color-grey-02 font-weight-700">Add Branch</p>
                        </div>
                      ) : (
                        <div className="d-flex flex-item margin-auto">
                          <div onClick={isButtonlock?null:UpdatePublishedMediaRecord(false,null)} className="d-flex cursor-pointer">
                            <svg className="flex-item m-r-8" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.0776 13.5854L2.92373 3.43154M0.667317 8.50846C0.667317 6.56354 1.43993 4.69828 2.8152 3.32301C4.19047 1.94775 6.05573 1.17513 8.00065 1.17513C9.94557 1.17513 11.8108 1.94775 13.1861 3.32301C14.5614 4.69828 15.334 6.56354 15.334 8.50846C15.334 10.4534 14.5614 12.3186 13.1861 13.6939C11.8108 15.0692 9.94557 15.8418 8.00065 15.8418C6.05573 15.8418 4.19047 15.0692 2.8152 13.6939C1.43993 12.3186 0.667317 10.4534 0.667317 8.50846Z" stroke="#E33A34" stroke-linejoin="round"/>
                            </svg>
                            <p className="flex-item color-red font-weight-600 fs-14">Block Selected</p>
                          </div>
                          <svg className="flex-item m-l-12 m-r-12" width="1" height="30" viewBox="0 0 1 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0.5" y1="29.0173" x2="0.5" y2="9.72748e-05" stroke="#DADADA"/>
                          </svg>
                          <div onClick={isButtonlock?null:UpdatePublishedMediaRecord(true,null)} className="d-flex cursor-pointer">
                            <svg className="flex-item m-r-8" width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.7837 1.79309C4.43714 1.84402 4.10398 1.96373 3.8034 2.14534C3.50283 2.32695 3.24076 2.56686 3.03232 2.85126C2.82387 3.13566 2.67315 3.45893 2.58884 3.80245C2.50453 4.14597 2.4883 4.50295 2.54109 4.85283L2.56598 5.02305C2.59916 5.23548 2.6542 5.44175 2.73108 5.64188L3.49023 7.60568C5.30665 7.48096 7.12969 7.49189 8.94452 7.63838L10.1857 7.739C10.576 7.77038 10.9445 7.93306 11.2325 8.20104C11.5206 8.46902 11.7114 8.82683 11.7745 9.2173C12.0752 11.0692 12.0752 12.9583 11.7745 14.8102C11.7116 15.2008 11.5208 15.5588 11.2328 15.827C10.9447 16.0951 10.5761 16.2579 10.1857 16.2893L8.94452 16.39C6.98462 16.5481 5.01538 16.5481 3.05548 16.39L1.81429 16.2893C1.42392 16.2579 1.05525 16.0951 0.767225 15.827C0.479196 15.5588 0.288443 15.2008 0.225464 14.8102C-0.0751545 12.9583 -0.0751545 11.0692 0.225464 9.2173C0.288311 8.82639 0.479111 8.4681 0.767322 8.19977C1.05553 7.93145 1.42449 7.76861 1.81512 7.73732L2.19428 7.70714L1.57203 6.09887C1.46225 5.81324 1.3838 5.51631 1.33806 5.21339L1.31234 5.04234C1.16801 4.08361 1.37851 3.10477 1.90356 2.29308C2.42861 1.48138 3.23134 0.893834 4.15818 0.64284C5.08502 0.391846 6.07088 0.49503 6.92716 0.93265C7.78343 1.37027 8.45 2.1116 8.79932 3.01481L8.86155 3.17664C8.97217 3.46286 9.05044 3.75829 9.09635 4.06295L9.21333 4.84109C9.22158 4.89555 9.21913 4.95111 9.20613 5.00461C9.19312 5.05811 9.16981 5.10849 9.13752 5.15288C9.10524 5.19727 9.06461 5.23479 9.01797 5.2633C8.97133 5.29182 8.91959 5.31076 8.8657 5.31905L8.45584 5.38194C8.40196 5.39028 8.34698 5.3878 8.29404 5.37466C8.24111 5.36151 8.19126 5.33795 8.14734 5.30532C8.10342 5.27269 8.06629 5.23163 8.03808 5.18449C8.00987 5.13736 7.99112 5.08506 7.98292 5.0306L7.86677 4.25246C7.83452 4.04074 7.77943 3.83323 7.70249 3.63363L7.64027 3.47264C7.42194 2.9079 7.0208 2.43454 6.50222 2.1297C5.98363 1.82485 5.37818 1.7065 4.78453 1.79393M6.00083 10.756C5.67076 10.756 5.35422 10.8885 5.12083 11.1244C4.88744 11.3602 4.75632 11.6802 4.75632 12.0137C4.75632 12.3473 4.88744 12.6672 5.12083 12.9031C5.35422 13.139 5.67076 13.2715 6.00083 13.2715C6.33089 13.2715 6.64744 13.139 6.88083 12.9031C7.11422 12.6672 7.24534 12.3473 7.24534 12.0137C7.24534 11.6802 7.11422 11.3602 6.88083 11.1244C6.64744 10.8885 6.33089 10.756 6.00083 10.756Z" fill="#5D883C"/>
                            </svg>
                            <p className="flex-item color-green font-weight-600 fs-14">Unblock Selected</p>
                          </div>
                        </div> 
                      )
                    }
                  </div>
                </div>
              </div>
            ) : (
              <div className="horizontal-ads-scroll-container" style={{width: !mediaRecord.isMainScreenBanner ? "55%" : "100%", paddingTop: mediaRecord.isMainScreenBanner ? "12px" : "6px"}}>
                {
                  mediaRecord.isMainScreenBanner && (
                    <div className="w-full">
                      <div className="d-flex space-between p-l-12 p-r-12">
                        <div className="flex-item">
                          {mediaRecord.name&&<p className="fs-18 font-weight-600" style={{lineHeight:"24px"}}>{mediaRecord.name}</p>}
                          <p className="color-red m-t-4" style={{lineHeight:"14px"}}>{showLiveDeviceCount(selectedBranchList)} Devices</p>
                        </div>
                        <div onClick={()=>toggleAdsView()} className="table-action-button d-flex cursor-pointer" style={{backgroundColor: isAdsViewVisible ? "#E33A34" : "#ffffff"}}>
                          <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isAdsViewVisible ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isAdsViewVisible ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                          </svg>
                        </div>
                      </div>
                      {
                        isAdsViewVisible && horizontalAds()
                      }
                      <div className="w-full p-l-12 p-r-12 m-t-12 m-b-12">
                        <svg className="flex-item" width="100%" height="2" viewBox="0 0 403 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="-0.00195312" y1="0.5" x2="402.998" y2="0.5" stroke="#B8B8B8" stroke-dasharray="6 6"/>
                        </svg>
                      </div>
                    </div>
                  )
                }
                
                <div className="w-full p-l-12 p-r-12">
                  <SearchFilter search={handleBranchSearchKey.bind(this)} filterType={'gym-filter'} count={total.branch} searchType={"Branch"} isSticky={false} searchContainerWidth="90%"/>
                  <div className="d-flex w-full m-b-8"/>
                  <div className="apk-branch-list" onScroll={handleScrollBranch} style={!mediaRecord.isMainScreenBanner?{height:'58vh',overflowY:'auto'}:{maxHeight:400,overflowY:'auto',marginBottom:20}}>
                    {
                      branchList.map((data, index) => {
                        return(
                          <div className={`${currentSelectedBranch == index &&  "scaleFromTopToBottom"} w-full m-t-12`} style={{borderBottom: branchList.length  != index + 1 ? "1px solid #e0e0e0" : "", paddingBottom: currentBranch == index && "14px"}}>
                            <div className="d-flex space-between m-b-16">
                              <div onClick={()=>handleBranchList(index)} className="d-flex">
                                <input className="flex-item device-checkbox m-r-8" type="checkbox" checked={data.isSelected} />
                                <div className="d-flex">
                                  {
                                    data.gym[0].logoFileID?(
                                      <div className="table-item-profile d-flex flex-item">
                                        <img className="flex-item" src={`${client.config.API_URL}/image/file/${data.gym[0].logoFileID}/auto/auto/70`} />
                                      </div>
                                    ):(
                                      <div className="gym-logo m-r-8 m-t-1" style={{backgroundColor: data.gym[0].logoPlaceholderColor ? data.gym[0].logoPlaceholderColor : "#5d883c"}}>
                                          <div className='d-flex w-full h-full'>
                                            <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${data.gym[0].name}`.trim()[0]}</p>
                                          </div>
                                      </div>
                                    )
                                  }
                          
                                  <div className="flex-item m-l-8">
                                    <p className="fs-16 font-weight-600 color-dark-blue" style={{lineHeight:"16px"}}>{data.name}</p>
                                    <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{data.devices.length} Device{data.devices.length > 1 && "s"}</p>
                                  </div>
                                </div>
                              </div>
                              <div onClick={()=>toggleBranchExpand(index)} className="table-action-button d-flex cursor-pointer" style={{backgroundColor: currentBranch == index ? "#E33A34" : "#ffffff"}}>
                                <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: currentBranch == index ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={currentBranch == index ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                                </svg>
                              </div>
                            </div>
                            {
                              currentBranch == index && (
                                data.devices.map((device, deviceIndex) => {
                                  return(
                                    <div onClick={()=> device.isActive?handleDeviceSelect("unselected-branch", index, deviceIndex): handleDeviceState("unselected-branch",index, deviceIndex)} className="d-flex m-l-32 m-b-6 cursor-pointer">
                                      {
                                        device.isActive ? (
                                          <input className="device-checkbox m-r-8 m-t-4" type="checkbox" checked={device.isSelected} />                                
                                        ) : (
                                          <svg className="m-r-8 m-t-3" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 8H15M8 15V1" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>
                                        )
                                      }
                                      <div className="m-l-10">
                                        <div className="d-flex m-t-5">
                                          <p className="flex-item m-r-8 font-weight-600 color-black" style={{lineHeight:"14px"}}>{device.name?device.name:device.deviceID}</p>                                  
                                          {
                                            device.isActive && (
                                              <div className="flex-item status-icon m-r-8" />
                                            )
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              )
                            }
                            <div className="modal-bottom-action-container d-flex w-full p-l-12 p-r-12">
                              <div className="d-flex margin-auto space-between flex-item" style={{width : !mediaRecord.isMainScreenBanner ? "50%" : "100%"}}>
                                <div onClick={()=>toggleCurrentView("ads-preview")} className="global-button-container d-flex flex-item" style={{borderRadius:"20px", width:"26%"}}>
                                  <p className="flex-item">Cancel</p>
                                </div>
                                <div onClick={handleSelectNewBranch} className="global-button-container global-button-container-active d-flex flex-item" style={{borderRadius:"20px", width:"68%"}}>
                                  <p className="flex-item">Add Selected Branch's</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                    {startBranchLoader && <div className="loader-5 center"><span></span></div>}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default LiveAdsPreviewModal;